import { useMutation as useApolloMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

import type { Response, MutationVars } from './mutation'
import updateExecutiveMutation from './mutation'

export const useMutation: WrappedMutation<Response, MutationVars> = () =>
  useApolloMutation<Response, MutationVars>(updateExecutiveMutation, {
    client: agentClient,
    fetchPolicy: 'network-only',
  })
